
import { Component, Vue, Prop, Inject } from 'nuxt-property-decorator';
import { v4 as uuid } from 'uuid';

@Component({})
export default class MoneyInput extends Vue {
  @Prop({ type: [String, Number], default: 0 }) readonly value!: string | number | null;
  @Prop({ type: String, required: true }) readonly name!: string;
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Number, default: 2 }) readonly precision!: number;
  @Prop({ type: String, default: null }) readonly help!: string | null;
  @Prop({ type: [String, Object], default: '' }) readonly validations!: string | object;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(Boolean) readonly required!: boolean;
  @Prop(Boolean) readonly hideLabel!: boolean;

  @Inject() $validator;

  inputId = uuid();

  get innerValue(): number {
    if (!this.value) return 0;
    return typeof this.value === 'string' ? parseFloat(this.value) : this.value;
  }

  set innerValue(newValue: number) {
    if (newValue !== this.value) this.$emit('input', newValue);
  }

  get validationErrors() {
    if (this.errors && this.errors.items && this.errors.items.some(e => e.id === this.name)) {
      return this.errors.items.find(x => x.id === this.name)?.msg || '';
    }
    return this.errors.first(this.name);
  }
}
